module.exports = __webpack_public_path__ + "../resources/img/text.8ea2e24f.png";